// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"DatePicker_tooltip__EyldC"};